import { useEffect, useState } from 'react'

import { PagesAmountOfPagesDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { UploadFilesModal } from 'modules/pages/components/UploadFilesModal'

import { EmptyState } from './components/EmptyState'
import { FoldersTable } from './components/FoldersTable'

const FoldersOverview = () => {
  const { data, loading, error } = useQuery(PagesAmountOfPagesDocument)
  const [openModal, setOpenModal] = useState(false)

  const amountOfPages = data?.handbookPages.pagesConnection.totalCount ?? 0

  useEffect(() => {
    if (!loading && !error) {
      track(trackingEvents.pages.PagesViewed, {
        view_state: amountOfPages > 0 ? 'with_policies' : 'blank_state',
      })
    }
  }, [loading, error, amountOfPages])

  return (
    <ResponsivePage.Body loading={loading} error={error}>
      {amountOfPages > 0 ? (
        <FoldersTable setOpenModal={setOpenModal} />
      ) : (
        <EmptyState setOpenModal={setOpenModal} />
      )}

      {openModal && <UploadFilesModal isOpen={openModal} onClose={() => setOpenModal(false)} />}
    </ResponsivePage.Body>
  )
}

export default FoldersOverview
